import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import _moment from 'moment';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepicker } from '@angular/material/datepicker';
import { FunctionsService } from 'brainloper-ui';

const moment =  _moment;

const YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

const MONTH_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM/YYYY',
  },
};

const DEFAULT_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'DD/MM/YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD/MM/YYYY',
  },
};


@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS,
            useFactory: dateFormatFactory,
            deps: [MAT_DATE_LOCALE, DateComponent]
        },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DateComponent implements OnInit {

  @Input() appearance: any = "";
  @Input() type:string = '';
  @Input() label: string = null
  @Input() matHint: boolean = true
  @Input() value:string = null
  @Output() dateSelected = new EventEmitter<string>();

  public movil = false;

  public date = new UntypedFormControl();
  public fullDate = new UntypedFormControl(null);

  constructor(
    private functions: FunctionsService
  ) { }

  ngOnInit(): void {
    this.movil = screen.width > 600 ? false : true
    if(this.label == null){
      switch (this.type) {
        case 'year':
          this.label = 'Año'
          break;
        case 'month':
          this.label = 'Mes y Año'
            break;
        default:
          this.label = 'Fecha'
          break;
      }
    }
    if(this.value){
      this.date.setValue(moment(this.parseDateString(this.value.toString())))
    }
  }

  public chosenDateHandlerYear(normalizedYear: _moment.Moment, datepicker: MatDatepicker<_moment.Moment>){
    const ctrlValue = this.date.value ?? normalizedYear
    ctrlValue.year(normalizedYear.year())
    this.date.setValue(ctrlValue)
    datepicker.close()
    let date = new Date (this.functions.dateForm(this.date.value['_d']))
    let yearSelectd = date.getFullYear()
    this.dateSelected.emit(yearSelectd.toString())
  }

  public chosenDateHandlerMonth(normalizedMonth: _moment.Moment, datepicker: MatDatepicker<_moment.Moment>){
    const ctrlValue = this.date.value ?? normalizedMonth;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue)
    datepicker.close();
    let date = new Date (this.functions.dateForm(this.date.value['_d']))
    let dateAdapter = this.functions.dateDB(date).split("-")
    let dateSelect = `${dateAdapter[0]}-${dateAdapter[1]}`
    this.dateSelected.emit(dateSelect)
  }

  public chosenDateHandlerDate(){
    this.dateSelected.emit(this.functions.dateDB(this.fullDate.value['_d']))
  }

  private parseDateString(dateString:string):Date {
    const parts = dateString.split('-');
    let year: number, month: number, day: number

    if (parts.length === 1) {

      year = parseInt(parts[0]);
      return new Date(year, 0, 1);
    } else if (parts.length === 2) {
      // Año y mes
      year = parseInt(parts[0]);
      month = parseInt(parts[1]) - 1;
      return new Date(year, month, 1);
    } else if (parts.length === 3) {

      year = parseInt(parts[0]);
      month = parseInt(parts[1]) - 1;
      day = parseInt(parts[2]);
      return new Date(year, month, day);
    } else {

      return new Date();
    }
  }

}

function dateFormatFactory(locale: string, component: DateComponent) {
  switch (component.type) {
    case 'year':
      return YEAR_FORMATS;
    case 'month':
      return MONTH_FORMATS;
    default:
      return DEFAULT_FORMATS;
  }
}
